import { Box, Paper, Skeleton, TableBody, TableContainer, TableHead, TableRow, Typography, Button } from "@mui/material";
import { List, useListContext, useRedirect } from "react-admin";

//Common styles
import {
  CustomTableRowTR,
  FilledButton,
  StyledTable,
  TableData,
  TableHeader,
  TableTopHeader,
  TableWrapper,
  Title,
  WorkspaceContainer,
} from "../../styles/commonStyles";

const SKELETON_ROWS = 5;
const COLUMN_COUNT = 6;

const StatusBadge = ({ isActive }: { isActive: boolean }) => (
  <Box
    sx={{
      display: "inline-flex",
      alignItems: "center",
      padding: "4px 10px",
      borderRadius: "999px",
      fontSize: "12px",
      fontWeight: 600,
      textTransform: "uppercase",
      backgroundColor: isActive
        ? "rgba(46, 125, 50, 0.12)"
        : "rgba(211, 47, 47, 0.12)",
      color: isActive ? "#2E7D32" : "#D32F2F",
    }}
  >
    {isActive ? "Active" : "Inactive"}
  </Box>
);

const DishCategoryTagCustomTable = () => {
  const { data = [], isLoading } = useListContext();
  const redirect = useRedirect();

  if (isLoading) {
    return (
      <TableWrapper>
        <TableTopHeader>
          <Title>Dish Category Tags</Title>
          <Button
            variant="outlined"
            size="small"
            onClick={() => redirect("create", "DishCategoryTag")}
          >
            Create
          </Button>
        </TableTopHeader>

        <TableContainer
          component={Paper}
          sx={{ backgroundColor: "transparent", boxShadow: "none", overflow: "visible" }}
        >
          <StyledTable>
            <TableHead>
              <TableRow sx={{ backgroundColor: "rgba(232,235,237,0.3)" }}>
                {Array.from({ length: COLUMN_COUNT }).map((_, i) => (
                  <TableHeader key={i}> </TableHeader>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {Array.from({ length: SKELETON_ROWS }).map((_, i) => (
                <CustomTableRowTR key={i}>
                  {Array.from({ length: COLUMN_COUNT }).map((__, j) => (
                    <TableData key={j}>
                      <Skeleton height={28} />
                    </TableData>
                  ))}
                </CustomTableRowTR>
              ))}
            </TableBody>
          </StyledTable>
        </TableContainer>
      </TableWrapper>
    );
  }

  if (!data.length) {
    return (
      <Box py={4} textAlign="center">
        <Typography color="text.secondary">No dish category tags found</Typography>
      </Box>
    );
  }

  return (
    <TableWrapper>
      <TableTopHeader>
        <Title>Dish Category Tags</Title>
        <Button
          variant="outlined"
          size="small"
          onClick={() => redirect("create", "DishCategoryTag")}
        >
          Create
        </Button>
      </TableTopHeader>

      <TableContainer
        component={Paper}
        sx={{ backgroundColor: "transparent", boxShadow: "none", overflow: "visible" }}
      >
        <StyledTable>
          <TableHead>
            <TableRow sx={{ backgroundColor: "rgba(232,235,237,0.3) !important" }}>
              <TableHeader>Id</TableHeader>
              <TableHeader>Name</TableHeader>
              <TableHeader>Slug</TableHeader>
              <TableHeader>Icon</TableHeader>
              <TableHeader>Status</TableHeader>
              <TableHeader>Action</TableHeader>
            </TableRow>
          </TableHead>

          <TableBody>
            {data.map((row: any) => (
              <CustomTableRowTR
                key={row.id}
                sx={{ cursor: "pointer" }}
                onClick={() => redirect("show", "DishCategoryTag", row.id)}
              >
                <TableData>{row.id}</TableData>
                <TableData>{row.name || "-"}</TableData>
                <TableData>{row.slug || "-"}</TableData>
                <TableData>
                  {row.iconUrl ? (
                    <Box
                      component="img"
                      src={row.iconUrl}
                      alt={row.name}
                      sx={{
                        width: 40,
                        height: 40,
                        borderRadius: "6px",
                        objectFit: "cover",
                        border: "1px solid #e0e0e0",
                      }}
                      onError={(e: any) => {
                        e.target.src = "/images/image-placeholder.png";
                      }}
                    />
                  ) : (
                    <Typography variant="body2" color="text.secondary">
                      N/A
                    </Typography>
                  )}
                </TableData>
                <TableData>
                  <StatusBadge isActive={!!row.isActive} />
                </TableData>
                <TableData>
                  <FilledButton
                    size="small"
                    variant="text"
                    onClick={(e) => {
                      e.stopPropagation();
                      redirect("show", "DishCategoryTag", row.id);
                    }}
                  >
                    Show
                  </FilledButton>
                </TableData>
              </CustomTableRowTR>
            ))}
          </TableBody>
        </StyledTable>
      </TableContainer>
    </TableWrapper>
  );
};

const DishCategoryTagList = (props: any) => {
  return (
    <WorkspaceContainer>
      <List
        {...props}
        actions={false}
        sx={{
          "& .RaLayout-content": { overflow: "visible", backgroundColor: "transparent" },
          "& main": { overflow: "visible", backgroundColor: "transparent" },
          "& .RaList-root": { backgroundColor: "transparent" },
          "& .RaList-content": { backgroundColor: "transparent" },
          overflow: "visible",
          backgroundColor: "transparent",
        }}
      >
        <DishCategoryTagCustomTable />
      </List>
    </WorkspaceContainer>
  );
};

export default DishCategoryTagList;
